import { money } from '@io/builder';

import { Money } from '@ap/interface-bspc-core';
import { LoanToValueBodyParams } from '@ap/ap-interface-apix-rs-hypotheken-renteoverzicht';

export class LoanToValueBodyParamsBuilder {
    private mortgage: Money;
    private purchasePrice: Money;

    withMortgage(amount: string) {
        this.mortgage = money(amount);
        return this;
    }

    withPurchasePrice(amount: string) {
        this.purchasePrice = money(amount);
        return this;
    }

    build(): LoanToValueBodyParams {
        return {
            mortgage_amount: this.mortgage,
            purchase_price: this.purchasePrice
        } as LoanToValueBodyParams;
    }
}
